import { render } from "./SettingsView.vue?vue&type=template&id=d9f2676c"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "d9f2676c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9f2676c', script)) {
    api.reload('d9f2676c', script)
  }
  
  module.hot.accept("./SettingsView.vue?vue&type=template&id=d9f2676c", () => {
    api.rerender('d9f2676c', render)
  })

}

script.__file = "src/views/settings/SettingsView.vue"

export default script